<navaar-container-scroll
    class="list-categories"
    id="edit-profile-wrapper"
    [showHeader]="true"
    [title]="'ویرایش کاربری'"
    [show]="true"
    [isPlayAnimation]="false"
    [showIcon]="true"
    [isFixedContainer]="true"
    [back-url]="['/profile']"
>
    <div class="container profile-edit-container" style="padding-bottom: 16px;">
        <form
            [formGroup]="userForm"
            autocomplete="off"
            class="form-container"
        >
            <div class="form-row">
                <label for="firstname">نام</label>
                <div class="form-group">
                    <input
                        type="text"
                        formControlName="firstName"
                        id="firstName"
                    >
                </div>
            </div>
            <div class="form-row">
                <label for="lastName">نام خانوادگی</label>
                <div class="form-group">
                    <input
                        type="text"
                        formControlName="lastName"
                        id="lastName"
                    >
                </div>
            </div>
            <div class="form-row">
                <label for="birthdate-val">تاریخ تولد</label>
                <div class="form-group">
                    <input
                        (click)="openDialog(dialogItems.birthdate)"
                        type="text"
                        id="birthdate-val"
                        [value]="birthJal || ''"
                        readonly
                    >
                </div>
            </div>
            <div class="form-row">
                <label for="gender">جنسیت</label>
                <div class="form-group">
                    <input
                        (click)="openDialog(dialogItems.gender)"
                        type="text"
                        [value]="userForm.get('gender')?.value == 0 ? 'مرد' : userForm.get('gender')?.value == 1 ? 'زن' : null"
                        readonly
                    >
                </div>
            </div>
            <div class="form-row">
                <label for="occupation">شغل</label>
                <div class="form-group">
                    <input
                        (click)="openDialog(dialogItems.occupation)"
                        type="text"
                        id="occupation"
                        [value]="selectOccupation ? selectOccupation?.title : null"
                        readonly
                    >
                </div>
            </div>
            <div class="form-row">
                <label for="mobileNo">شماره تلفن</label>
                <div class="form-group">
                    <input
                        type="text"
                        formControlName="mobileNo"
                        id="mobileNo"
                        style="direction: initial;"
                    >
                </div>
            </div>
            <div class="form-row">
                <label for="email">ایمیل</label>
                <div class="form-group">
                    <input
                        (click)="openDialog(dialogItems.email)"
                        type="email"
                        formControlName="email"
                        id="email"
                        [value]="userForm.get('email').value"
                    >
                </div>
            </div>
            <div
                class="form-row"
                *ngIf="!isMobileSignedUp"
            >
                <label for="password">رمز عبور</label>
                <div class="form-group">
                    <input
                        (click)="openDialog(dialogItems.password)"
                        type="password"
                        id="password"
                        [value]="'********'"
                    >
                </div>
            </div>
            <div style="margin-top: 30px">
                <navaar-button
                    (onClick)="setUserData()"
                    [type-button]="'submit'"
                    [color-name]="'blue'"
                    [class-name]="'btn-submit-feedback'"
                    [disabled]="isSaving"
                >
                    ذخیره
                </navaar-button>
            </div>
        </form>
    </div>
</navaar-container-scroll>
<ng-container *ngIf="isShowDialog">
    <div
        class="overlay"
        (swipedown)="closeDialog()"
        (click)="closeDialog()"
    ></div>
    <div
        (swipedown)="closeDialog()"
        [@slidePopup]
        [formGroup]="userForm"
        class="container-scroll-div"
        [style.max-height.px]="calculateHeight()"
    >
        <div class="wrapper-scroll-div" [style.max-height.px]="calculateHeight()">
            <section class="wrapper-item">
                <ng-container [ngSwitch]="dialogType">
                    <ng-container *ngSwitchCase="dialogItems.gender">
                        <fieldset>
                            <div class="toggle">
                                <input
                                    type="radio"
                                    formControlName="gender"
                                    [value]="1"
                                    id="radio-btn-woman"
                                    (click)="saveGender(1)"
                                >
                                <label for="radio-btn-woman">زن</label>
                                <input
                                    type="radio"
                                    formControlName="gender"
                                    [value]="0"
                                    id="radio-btn-man"
                                    (click)="saveGender(0)"
                                >
                                <label for="radio-btn-man">مرد</label>
                            </div>
                        </fieldset>
                    </ng-container>
                    <ng-container *ngSwitchCase="dialogItems.birthdate">
                        <div class="container-dialog-birthdate">
                            <div class="wrapper-selects">
                                <div>
                                    <label>روز</label>
                                    <navaar-dropdown
                                        [items]="days"
                                        [(selected)]="selectDay"
                                    ></navaar-dropdown>
                                </div>
                                <div>
                                    <label>ماه</label>
                                    <navaar-dropdown
                                        [items]="months"
                                        [(selected)]="selectMonth"
                                    ></navaar-dropdown>
                                </div>
                                <div>
                                    <label>سال</label>
                                    <navaar-dropdown
                                        [items]="years.reverse()"
                                        [(selected)]="selectYear"
                                    ></navaar-dropdown>
                                </div>
                            </div>
                            <div class="wrapper-btns">
                                <div>
                                    <navaar-button
                                        [type-button]="'button'"
                                        [color-name]="'blue'"
                                        (onClick)="saveBirthdate()"
                                        [disabled]="!selectYear || !selectMonth || !selectDay"
                                    >
                                        <span>انتخاب</span>
                                    </navaar-button>
                                </div>
                                <div>
                                    <navaar-button
                                        [type-button]="'button'"
                                        [color-name]="'green'"
                                        (onClick)="closeDialog()"
                                    >
                                        <span>انصراف</span>
                                    </navaar-button>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="dialogItems.occupation">
                        <div class="container-dialog-occupation">
                            <div class="wrapper-selects">
                                <div>
                                    <label>شغل</label>
                                    <navaar-dropdown
                                        [items]="occupations"
                                        [(selected)]="selectOccupation"
                                        [showIcon]="true"
                                    ></navaar-dropdown>
                                </div>
                            </div>
                            <div class="wrapper-btns">
                                <div>
                                    <navaar-button
                                        [type-button]="'button'"
                                        [color-name]="'blue'"
                                        (onClick)="saveOccupation()"
                                        [disabled]="!selectOccupation"
                                    >
                                        <span>انتخاب</span>
                                    </navaar-button>
                                </div>
                                <div>
                                    <navaar-button
                                        [type-button]="'button'"
                                        [color-name]="'green'"
                                        (onClick)="closeDialog()"
                                    >
                                        <span>انصراف</span>
                                    </navaar-button>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="dialogItems.email">
                        <form
                            [formGroup]="emailForm"
                            autocomplete="off"
                            class="form-container"
                            id="email-wrapper"
                        >
                            <p class="label-header-box">تغییر ایمیل</p>
                            <div class="form-row">
                                <label for="email">ایمیل جدید</label>
                                <div
                                    class="form-group"
                                    [class.error]="emailForm.get('email').touched && emailForm.get('email').dirty && !emailForm.get('email').valid"
                                >
                                    <input
                                        formControlName="email"
                                        type="email"
                                        id="email"
                                        style="direction: ltr;text-align: left;"
                                        required
                                    >
                                </div>
                            </div>
                            <div class="form-row">
                                <label for="emailConfirm">تکرار ایمیل جدید</label>
                                <div
                                    class="form-group"
                                    [class.error]="emailForm.get('emailConfirm').touched && emailForm.get('emailConfirm').dirty && !emailForm.get('emailConfirm').valid"
                                >
                                    <input
                                        formControlName="emailConfirm"
                                        type="email"
                                        id="emailConfirm"
                                        style="direction: ltr;text-align: left;"
                                        required
                                    >
                                </div>
                            </div>
                            <div
                                class="form-row"
                                *ngIf="!isMobileSignedUp"
                            >
                                <label for="password">رمز عبور فعلی</label>
                                <div
                                    class="form-group"
                                    [class.error]="emailForm.get('password').touched && emailForm.get('password').dirty && !emailForm.get('password').valid"
                                >
                                    <input
                                        formControlName="password"
                                        type="password"
                                        id="password"
                                        style="direction: ltr;text-align: left;"
                                        required
                                    >
                                </div>
                            </div>
                            <div class="wrapper-btns">
                                <div>
                                    <navaar-button
                                        [type-button]="'button'"
                                        [color-name]="'blue'"
                                        (onClick)="updateEmail()"
                                        [disabled]="!emailForm.valid || isSaving"
                                    >
                                        <span>ذخیره</span>
                                    </navaar-button>
                                </div>
                                <div>
                                    <navaar-button
                                        [type-button]="'button'"
                                        [color-name]="'green'"
                                        (onClick)="closeDialog()"
                                    >
                                        <span>انصراف</span>
                                    </navaar-button>
                                </div>
                            </div>
                        </form>
                    </ng-container>
                    <ng-container *ngSwitchCase="dialogItems.password">
                        <form
                            [formGroup]="passForm"
                            autocomplete="off"
                            class="form-container"
                            id="password-wrapper"
                        >
                            <p class="label-header-box">تغییر رمز عبور</p>
                            <div class="form-row">
                                <label for="oldPassword">رمز عبور فعلی</label>
                                <div
                                    class="form-group"
                                    [class.error]="passForm.get('oldPassword').touched && passForm.get('oldPassword').dirty && !passForm.get('oldPassword').valid"
                                >
                                    <input
                                        formControlName="oldPassword"
                                        type="password"
                                        id="oldPassword"
                                        style="direction: ltr;text-align: left;"
                                        required
                                    >
                                </div>
                            </div>
                            <div class="form-row">
                                <label for="newPassword">رمز عبور جدید</label>
                                <div
                                    class="form-group"
                                    [class.error]="passForm.get('newPassword').touched && passForm.get('newPassword').dirty && !passForm.get('newPassword').valid"
                                >
                                    <input
                                        formControlName="newPassword"
                                        type="password"
                                        id="newPassword"
                                        style="direction: ltr;text-align: left;"
                                        autocomplete="new-password"
                                        required
                                    >
                                </div>
                            </div>
                            <div class="form-row">
                                <label for="confirm">تکرار رمز عبور جدید</label>
                                <div
                                    class="form-group"
                                    [class.error]="passForm.get('confirm').touched && passForm.get('confirm').dirty && !passForm.get('confirm').valid"
                                >
                                    <input
                                        formControlName="confirm"
                                        type="password"
                                        id="confirm"
                                        autocomplete="new-password"
                                        style="direction: ltr;text-align: left;"
                                        required
                                    >
                                </div>
                            </div>
                            <div class="wrapper-btns">
                                <div>
                                    <navaar-button
                                        [type-button]="'button'"
                                        [color-name]="'blue'"
                                        (onClick)="updatePass()"
                                        [disabled]="!passForm.valid || isSaving"
                                    >
                                        <span>ذخیره</span>
                                    </navaar-button>
                                </div>
                                <div>
                                    <navaar-button
                                        [type-button]="'button'"
                                        [color-name]="'green'"
                                        (onClick)="closeDialog()"
                                    >
                                        <span>انصراف</span>
                                    </navaar-button>
                                </div>
                            </div>
                        </form>
                    </ng-container>
                </ng-container>
            </section>
        </div>
    </div>
</ng-container>
